import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { AllergyDetail } from '@liza/ui/components/records';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
};

export const Allergy = ({ id }: Props): React.ReactElement => {
  const { t } = useTranslation('records');
  const trpc = useTRPC();

  const allergyQuery = useQuery(trpc.patient.allergy.get.queryOptions({ id }));

  return (
    <QueryStateHandler query={allergyQuery} emptyMessage={t('noAllergiesFound')}>
      {(data) => <AllergyDetail allergy={data.allergy} />}
    </QueryStateHandler>
  );
};
